import { FLEX_ARGS, GRID_ARGS, Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/container.gjs';

const GRID_ONLY_ARG_NAMES = Object.keys(GRID_ARGS.meta).filter(name => !(name in FLEX_ARGS.meta));

const METADATA = Metadata.define({
  // Direction is fixed by each variant, and grid args never apply to a flex element.
  omits: ['column', 'grid', 'reverse', ...GRID_ONLY_ARG_NAMES],
});

export default class SpdsLayoutFlexBase extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  grid = false;
}
